import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { ThemeContext } from "../Theme";
import { Icon } from "../Icon";

import styles from "./Button.scss";

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
const ButtonIcon = forwardRef(({ children, ...otherProps }, ref) => {
  return (
    <span className={styles.icon} ref={ref}>
      {children || <Icon size={Icon.Size.parent} {...otherProps} />}
    </span>
  );
});

ButtonIcon.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

ButtonIcon.defaultProps = {
  children: null,
};

ButtonIcon.contextType = ThemeContext;

ButtonIcon.displayName = "Button.Icon";

export default ButtonIcon;
